import React, { useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { Link, useNavigate } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const menuItems = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'About', path: '/about' },
    { name: 'Testimonials', path: '/testimonials' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Contact', path: '/contact' }
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Desktop Layout */}
        <div className="hidden md:flex flex-col items-center py-4">
          {/* Centered Logo */}
          <Link to="/" className="mb-4">
            <img 
              src="/hollis-logo.webp" 
              alt="Hollis K-9 Coaching" 
              className="h-14 w-auto transition-transform duration-300 hover:scale-105"
            />
          </Link>
          
          {/* Navigation Items Below Logo */}
          <div className="flex items-center space-x-1">
            {menuItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className="text-white hover:text-red-600 transition-colors duration-300 font-medium px-4 py-2 rounded-md hover:bg-red-950"
              >
                {item.name}
              </Link>
            ))}
            <Button
              onClick={() => navigate('/contact')}
              className="bg-red-600 hover:bg-red-700 text-white transition-all duration-300 ml-2"
            >
              <Phone className="w-4 h-4 mr-2" />
              Book Now
            </Button>
          </div>
        </div>

        {/* Mobile Layout */}
        <div className="md:hidden flex justify-center items-center py-4 relative">
          <Link to="/" className="flex-shrink-0">
            <img 
              src="/hollis-logo.webp" 
              alt="Hollis K-9 Coaching" 
              className="h-12 w-auto transition-transform duration-300 hover:scale-105"
            />
          </Link>
          
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="absolute right-0 text-white hover:text-red-600 transition-colors duration-300"
          >
            {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-black border-t border-red-900">
          <div className="px-2 pt-2 pb-3 space-y-1">
            {menuItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                onClick={() => setIsOpen(false)}
                className="block w-full text-center px-3 py-2 text-white hover:text-red-600 hover:bg-red-950 transition-all duration-300"
              >
                {item.name}
              </Link>
            ))}
            <Button
              onClick={() => {
                navigate('/contact');
                setIsOpen(false);
              }}
              className="w-full mt-2 bg-red-600 hover:bg-red-700 text-white transition-all duration-300"
            >
              <Phone className="w-4 h-4 mr-2" />
              Book Now
            </Button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
